import * as icons from 'core/icons';

const almacen = {
    id: 'almacen',
    title: 'Almacen',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'ubicaciones',
            title: 'Ubicaciones',
            type: 'item',
            visible: true,
            url: '/gestion/liquidaciones/liquidaciones',
            icon: icons.UbicacionesIcon,
            breadcrumbs: false
        },
        {
            id: 'articulos',
            title: 'Articulos',
            type: 'item',
            url: '/gestion/contraetiquetas/inventario',
            visible: true,
            icon: icons.InventarioIcon,
            breadcrumbs: false
        },
        {
            id: 'compras',
            title: 'Compras',
            type: 'item',
            url: '/gestion/contraetiquetas/adquisiciones',
            icon: icons.RecolectionIcon,
            visible: true,
            breadcrumbs: false
        },
        {
            id: 'inventario',
            title: 'Inventario',
            type: 'item',
            visible: true,
            url: '/gestion/liquidaciones/liquidaciones',
            icon: icons.StockIcon,
            breadcrumbs: false
        }
    ]
};

export default almacen;
